export default {
  zh: {
    title: '备注',
    placeholder: '请输入备注内容',
    add: '添加备注',
    remove: '删除备注',
    preview: '图片预览',
    contentRequired: '请输入待办内容'
  },
  tw: {
    title: '備註',
    placeholder: '請輸入備註內容',
    add: '新增備註',
    remove: '刪除備註',
    preview: '圖片預覽',
    contentRequired: '請輸入待辦內容'
  },
  nl: {
    title: 'Opmerking',
    placeholder: 'Voer een opmerking in',
    add: 'Opmerking toevoegen',
    remove: 'Opmerking verwijderen',
    preview: 'Afbeeldingsvoorbeeld',
    contentRequired: 'Voer de inhoud van de taak in'
  },
  uk: {
    title: 'Note',
    placeholder: 'Enter a note',
    add: 'Add note',
    remove: 'Delete note',
    preview: 'Image preview',
    contentRequired: 'Please enter a to-do item'
  },
  us: {
    title: 'Note',
    placeholder: 'Enter a note',
    add: 'Add note',
    remove: 'Delete note',
    preview: 'Image preview',
    contentRequired: 'Please enter a to-do item'
  },
  fr: {
    title: 'Remarque',
    placeholder: 'Saisissez une remarque',
    add: 'Ajouter une remarque',
    remove: 'Supprimer la remarque',
    preview: 'Aperçu de l’image',
    contentRequired: 'Veuillez saisir le contenu de la tâche'
  },
  de: {
    title: 'Notiz',
    placeholder: 'Notiz eingeben',
    add: 'Notiz hinzufügen',
    remove: 'Notiz löschen',
    preview: 'Bildvorschau',
    contentRequired: 'Bitte geben Sie den Inhalt der Aufgabe ein'
  },
  it: {
    title: 'Nota',
    placeholder: 'Inserisci una nota',
    add: 'Aggiungi nota',
    remove: 'Elimina nota',
    preview: 'Anteprima immagine',
    contentRequired: 'Inserisci il contenuto dell’attività'
  },
  ja: {
    title: 'メモ',
    placeholder: 'メモを入力してください',
    add: 'メモを追加',
    remove: 'メモを削除',
    preview: '画像プレビュー',
    contentRequired: 'タスクの内容を入力してください'
  },
  ko: {
    title: '메모',
    placeholder: '메모 내용을 입력하세요',
    add: '메모 추가',
    remove: '메모 삭제',
    preview: '이미지 미리보기',
    contentRequired: '할 일 내용을 입력하세요'
  },
  pt: {
    title: 'Observação',
    placeholder: 'Digite uma observação',
    add: 'Adicionar observação',
    remove: 'Excluir observação',
    preview: 'Pré-visualização da imagem',
    contentRequired: 'Digite o conteúdo da tarefa'
  },
  ru: {
    title: 'Примечание',
    placeholder: 'Введите примечание',
    add: 'Добавить примечание',
    remove: 'Удалить примечание',
    preview: 'Просмотр изображения',
    contentRequired: 'Введите содержание задачи'
  },
  es: {
    title: 'Nota',
    placeholder: 'Introduce una nota',
    add: 'Añadir nota',
    remove: 'Eliminar nota',
    preview: 'Vista previa de la imagen',
    contentRequired: 'Introduce el contenido de la tarea'
  }
}
